import type { ApiResponse } from "@/types";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { api } from "../api/api";
import { QUERY_KEYS } from "./queryKeys";

export function getSecretsQueryOptions(chatId: string) {
  return queryOptions({
    queryKey: [QUERY_KEYS.SECRETS, chatId],
    queryFn: () => api.listSecrets(chatId),
  });
}

export function useListSecrets(chatId: string) {
  return useQuery<ApiResponse<{ secretKeys: string[] }>>({
    queryKey: [QUERY_KEYS.SECRETS, chatId],
    queryFn: () => api.listSecrets(chatId),
    enabled: !!chatId,
  });
}
